/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Agents_Meta_DescriptionInputs */

const en_svc_agents_meta_description = /** @type {(inputs: Svc_Agents_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom AI agents for sales, support and operations: they follow up on leads, answer email and update your CRM, with a person approving what goes out.`)
};

const lv_svc_agents_meta_description = /** @type {(inputs: Svc_Agents_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Izstrādājam AI aģentus pārdošanai, klientu apkalpošanai un ikdienas darbam: tie seko pieteikumiem, atbild uz e-pastiem un atjaunina CRM ar cilvēka apstiprinājumu.`)
};

/**
* | output |
* | --- |
* | "Custom AI agents for sales, support and operations: they follow up on leads, answer email and update your CRM, with a person approving what goes out." |
*
* @param {Svc_Agents_Meta_DescriptionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_agents_meta_description = /** @type {((inputs?: Svc_Agents_Meta_DescriptionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Agents_Meta_DescriptionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_agents_meta_description(inputs)
	return en_svc_agents_meta_description(inputs)
});